'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Components


// Utils


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _sharingPopupActions = require('./sharingPopupActions');

var sharingPopupActions = _interopRequireWildcard(_sharingPopupActions);

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _PopupArrow = require('../../../../components/popupPanel/PopupArrow');

var _PopupArrow2 = _interopRequireDefault(_PopupArrow);

var _UserAccessList = require('./userAccessList/UserAccessList');

var _UserAccessList2 = _interopRequireDefault(_UserAccessList);

var _BoardSharingInputForm = require('./form/BoardSharingInputForm');

var _BoardSharingInputForm2 = _interopRequireDefault(_BoardSharingInputForm);

var _BoardSharingPublic = require('./publicLink/BoardSharingPublic');

var _BoardSharingPublic2 = _interopRequireDefault(_BoardSharingPublic);

var _userService = require('../../../../user/userService');

var userService = _interopRequireWildcard(_userService);

var _boardSharingHelpers = require('./boardSharingHelpers');

var _sharingUtilSelector = require('./sharingUtilSelector');

require('./BoardSharingPopup.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        fetchUsers: function fetchUsers(userIds) {
            return dispatch(userService.fetchUsers(userIds));
        },
        toggleShareForm: function toggleShareForm() {
            return dispatch(sharingPopupActions.toggleShareForm());
        },
        publiclyShareBoard: function publiclyShareBoard() {
            return dispatch(sharingPopupActions.publiclyShareBoard({ elementId: ownProps.currentBoardId }));
        },
        unsharePublicBoard: function unsharePublicBoard() {
            return dispatch(sharingPopupActions.unsharePublicBoard({ elementId: ownProps.currentBoardId }));
        }
    };
};

var BoardSharingPopup = (_dec = (0, _reactRedux.connect)(_sharingUtilSelector.boardSharingPopupSelector, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(BoardSharingPopup, _React$Component);

    function BoardSharingPopup() {
        _classCallCheck(this, BoardSharingPopup);

        var _this = _possibleConstructorReturn(this, (BoardSharingPopup.__proto__ || Object.getPrototypeOf(BoardSharingPopup)).call(this));

        _this.state = {
            upArrowPosition: {
                left: 0
            }
        };
        return _this;
    }

    /**
     * Need to wait until after the component has updated so we can get the new position of the popup.
     */
    /* eslint-disable react/no-did-update-set-state */


    _createClass(BoardSharingPopup, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.isMobileView) return;

            if (!prevProps.popupOpen && this.props.popupOpen || this.props.popupOpen && this.props.downArrowPosition !== prevProps.downArrowPosition) {
                var popupElement = _reactDom2.default.findDOMNode(this.refs.popup);
                if (!popupElement) return;

                var popupPosition = popupElement.getBoundingClientRect();

                var downArrowPosition = this.props.downArrowPosition;

                var leftPosition = Math.floor(downArrowPosition.left + downArrowPosition.width / 2 - popupPosition.left - _PopupArrow.POPUP_ARROW_WIDTH / 2);
                var upArrowPosition = {
                    left: leftPosition + 'px'
                };

                this.setState({ upArrowPosition: upArrowPosition });
            }
        }
        /* eslint-enable react/no-did-update-set-state */

    }, {
        key: 'render',
        value: function render() {
            var boardPermissions = this.props.boardPermissions;
            var upArrowPosition = this.state.upArrowPosition;


            return _react2.default.createElement(
                _PopupPanel2.default,
                _extends({}, this.props, { ref: 'popup', className: 'BoardSharingPopup', popupId: 'sharing' }),
                _react2.default.createElement(_PopupArrow2.default, { style: upArrowPosition }),
                _react2.default.createElement(
                    'div',
                    { className: 'share-content' },
                    _react2.default.createElement(
                        'p',
                        { className: 'title' },
                        _react2.default.createElement(
                            'span',
                            null,
                            'This board is'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: 'status' },
                            ' ',
                            (0, _boardSharingHelpers.sharedTitle)(boardPermissions).toLowerCase()
                        )
                    ),
                    _react2.default.createElement(_BoardSharingInputForm2.default, this.props),
                    _react2.default.createElement(_UserAccessList2.default, this.props),
                    _react2.default.createElement(_BoardSharingPublic2.default, this.props)
                )
            );
        }
    }]);

    return BoardSharingPopup;
}(_react2.default.Component)) || _class);


BoardSharingPopup.propTypes = {
    fetchUsers: _propTypes2.default.func,
    toggleShareForm: _propTypes2.default.func,
    sharingPopupState: _propTypes2.default.object,
    boardPermissions: _propTypes2.default.object,
    isShared: _propTypes2.default.bool,
    currentBoard: _propTypes2.default.object,
    currentBoardId: _propTypes2.default.string,
    popupOpen: _propTypes2.default.bool,
    downArrowPosition: _propTypes2.default.object,
    isMobileView: _propTypes2.default.bool
};

exports.default = BoardSharingPopup;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/BoardSharingPopup.js
// module id = 783
// module chunks = 0